import { Button } from "./ui/button";

/**
 * PageHeader unificado:
 * - Titulo grande
 * - Descripcion corta de ayuda (que hago aqui)
 * - Boton principal grande (accion mas importante)
 * - Acciones secundarias opcionales
 */
const PageHeader = ({ title, description, primaryAction, secondaryActions = [], children }) => {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between border-b border-stone-200 pb-5 mb-6">
      <div className="min-w-0">
        <h1 className="font-display text-3xl sm:text-4xl text-stone-900 leading-tight">{title}</h1>
        {description && (
          <p className="text-stone-600 mt-1.5 text-sm sm:text-base max-w-2xl">{description}</p>
        )}
        {children && <div className="mt-2">{children}</div>}
      </div>
      <div className="flex flex-wrap gap-2 items-center shrink-0">
        {secondaryActions.map((a, idx) => (
          <Button
            key={idx}
            variant="outline"
            size="lg"
            onClick={a.onClick}
            disabled={a.disabled}
            className="h-11"
            data-testid={a.testId}
          >
            {a.icon && <a.icon className="w-4 h-4 mr-2" />}
            {a.label}
          </Button>
        ))}
        {primaryAction && (
          <Button
            size="lg"
            onClick={primaryAction.onClick}
            disabled={primaryAction.disabled}
            className="h-11 px-5 bg-emerald-900 hover:bg-emerald-800 text-white font-semibold shadow-sm"
            data-testid={primaryAction.testId}
          >
            {primaryAction.icon && <primaryAction.icon className="w-4 h-4 mr-2" />}
            {primaryAction.label}
          </Button>
        )}
      </div>
    </div>
  );
};

export default PageHeader;
